// extracted by mini-css-extract-plugin
module.exports = {"back-container":"BackButton_back-container__dGOG0","back-arrow":"BackButton_back-arrow__LskIs","clicked":"BackButton_clicked__jUVJd"};